<template>
  <div class="_seafreighttracking global__scrollcustom">
    <div class="row m-0 h-100">
      <div class="w-100">
        <h5>Sea Freight Live GPS Tracking</h5>
        <p>Now you can locate your shipment by using Andalin Sea Freight Live GPS Tracking.</p>
        <b-embed
          type="iframe"
          aspect="16by9"
          :src="`https://sirius.searates.com/tracking?container=${containerNumber ? containerNumber.split(',')[0] : ''}&sealine=0`"
          allowfullscreen
        ></b-embed>
        <!-- container code example : MSCU1111333 -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SeaFreightTracking',
  props: {
    containerNumber: String
  }
}
</script>



// WEBPACK FOOTER //
// src/components/managementShipment/detail/SeaFreightTracking.vue